"use client";

import React, { FunctionComponent } from "react";
import { useState } from "react";
import { setCookie, getCookie } from "cookies-next";

const CookieNotice: FunctionComponent = () => {
  const [noticeDismissed, setNoticeDismissed] = useState(
    getCookie("cookieconsent_status") === "accepted",
  );

  const handleAccept = () => {
    var oneYear = new Date();
    oneYear.setFullYear(oneYear.getFullYear() + 1);

    setCookie("cookieconsent_status", "accepted", { expires: oneYear });
    setNoticeDismissed(true);
  };

  if (noticeDismissed) return null;

  return (
    <div
      tabIndex={-1}
      aria-hidden="false"
      className="fixed bottom-0 z-50 w-full overflow-y-auto overflow-x-hidden border-t border-gray-200 md:inset-x-0"
    >
      <div className="relative h-full w-full md:h-auto">
        <div className="relative bg-white shadow">
          <div className="container m-auto items-center justify-between p-6 lg:flex">
            <p className="mb-4 text-sm text-gray-500 lg:mb-0">
              We use our own cookies as well as third-party cookies on our
              websites to enhance your experience, analyze our traffic, and for
              security and marketing. Select &uml;Accept All&uml; to allow them
              to be used.
            </p>
            <div className="flex shrink-0 items-center gap-4 lg:pl-10">
              <button
                type="button"
                className="w-full rounded-lg bg-blue-700 px-4 py-2 text-center text-sm font-medium text-white hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 sm:w-auto"
                onClick={() => handleAccept()}
              >
                Accept all
              </button>
              <button
                type="button"
                className="absolute right-1 top-1 ml-auto rounded-lg bg-transparent p-1 text-sm text-gray-400 hover:bg-gray-200 hover:text-gray-900 lg:relative lg:inset-0"
                onClick={() => setNoticeDismissed(true)}
                sr-only="Close"
                aria-label="Close"
              >
                <svg
                  className="h-5 w-5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieNotice;
